import { useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { Student } from "@/types/models/Student.interface";

export const useGetStudent = (enabled: boolean = true) => {
  const query = useQuery({
    queryKey: [ApiCatalog.student.key, "me"],
    queryFn: async () => await api().get<Student>(ApiCatalog.student.endpoint),
    enabled,
  });

  return { ...query, loading: query.isLoading };
};

export default useGetStudent;
